import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { FaSearch, FaStar, FaBook } from 'react-icons/fa';
import api from '../services/api';

const CATEGORIAS = [
  { value: 'cadastros', label: 'Cadastros', color: '#1565c0' },
  { value: 'financeiro', label: 'Financeiro', color: '#2e7d32' },
  { value: 'espacos', label: 'Espaços', color: '#5d4037' },
  { value: 'eventos', label: 'Eventos', color: '#e65100' },
  { value: 'atendimento', label: 'Atendimento', color: '#6a1b9a' },
  { value: 'duvidas', label: 'Dúvidas', color: '#f57c00' },
  { value: 'manual', label: 'Manual', color: '#00838f' },
  { value: 'outro', label: 'Outros', color: '#757575' }
];

const BaseConhecimentoAssociado = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [filtroCat, setFiltroCat] = useState('');
  const [preview, setPreview] = useState(null);

  useEffect(() => { loadArticles(); }, []);

  const loadArticles = async () => {
    setLoading(true);
    try {
      const res = await api.get('/knowledge/member');
      if (res.data.success) setArticles(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = articles.filter(a => {
    if (filtroCat && a.categoria !== filtroCat) return false;
    if (busca) {
      const b = busca.toLowerCase();
      return (a.titulo || '').toLowerCase().includes(b) || (a.conteudo || '').toLowerCase().includes(b) || (a.tags || []).some(t => (t || '').includes(b));
    }
    return true;
  });

  const destaques = filtered.filter(a => a.destaque);
  const normal = filtered.filter(a => !a.destaque);

  const getCatLabel = (c) => CATEGORIAS.find(x => x.value === c)?.label || c;
  const getCatColor = (c) => CATEGORIAS.find(x => x.value === c)?.color || '#757575';

  const tagStyle = (color) => ({ padding: '3px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: '700', fontFamily: 'Montserrat', backgroundColor: color + '22', color, display: 'inline-block' });
  const cardStyle = { backgroundColor: '#fff', borderRadius: '16px', padding: '18px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #edf2f7', cursor: 'pointer', transition: 'transform 0.15s, box-shadow 0.15s' };
  const containerStyle = { padding: '20px', maxWidth: '900px', margin: '0 auto' };

  const stripHtml = (html) => {
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  const renderizarHtml = (texto) => {
    if (!texto) return null;
    if (texto.includes('<')) {
      return (
        <div style={{ overflow: 'hidden', wordBreak: 'break-word' }}>
          <style>{`
            .kb-content img, .kb-content video, .kb-content iframe, .kb-content table { max-width: 100% !important; height: auto !important; }
          `}</style>
          <div className="kb-content" dangerouslySetInnerHTML={{ __html: texto }} style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px', lineHeight: '1.7' }} />
        </div>
      );
    }
    return texto.split('\n').map((p, i) => p.trim() ? <p key={i} style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px', lineHeight: '1.7', color: '#333', marginBottom: '8px' }}>{p}</p> : <br key={i} />);
  };

  return (
    <Layout title="Informações Úteis">
      <div style={containerStyle}>

        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ fontFamily: 'Montserrat', fontSize: '18px', fontWeight: '700', color: '#1A3B7D', marginBottom: '12px' }}>
            Encontre informações sobre o clube
          </h2>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
              <FaSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
              <input style={{ width: '100%', padding: '10px 12px 10px 36px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', boxSizing: 'border-box' }}
                placeholder="Buscar..." value={busca} onChange={e => setBusca(e.target.value)} />
            </div>
            <select style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', fontFamily: 'Montserrat', backgroundColor: '#fff' }}
              value={filtroCat} onChange={e => setFiltroCat(e.target.value)}>
              <option value="">Todas as categorias</option>
              {CATEGORIAS.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontFamily: 'Montserrat' }}>Carregando...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontFamily: 'Montserrat' }}>Nenhum artigo encontrado</div>
        ) : (
          <div>
            {destaques.length > 0 && (
              <>
                <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: '700', color: '#f39c12', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FaStar size={14} /> Principais
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '12px', marginBottom: '24px' }}>
                  {destaques.map(a => (
                    <div key={a._id} style={{ ...cardStyle }} onClick={() => setPreview(a)}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                        <span style={tagStyle(getCatColor(a.categoria))}>{getCatLabel(a.categoria)}</span>
                        <span style={{ ...tagStyle('#f39c12'), backgroundColor: '#fff3e0', color: '#f39c12' }}><FaStar size={9} /> Destaque</span>
                      </div>
                      <div style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '700', color: '#1A3B7D', marginBottom: '6px' }}>{a.titulo}</div>
                      <div style={{ fontFamily: 'Montserrat', fontSize: '12px', color: '#666', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                        {stripHtml(a.conteudo)?.substring(0, 150)}...
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: '700', color: '#555', marginBottom: '10px' }}>
              {normal.length} artigo{normal.length !== 1 ? 's' : ''}
            </div>
            <div>
              {normal.map(a => (
                <div key={a._id} style={{ ...cardStyle, marginBottom: '10px' }} onClick={() => setPreview(a)}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <span style={tagStyle(getCatColor(a.categoria))}>{getCatLabel(a.categoria)}</span>
                  </div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '700', color: '#1A3B7D', marginBottom: '6px' }}>{a.titulo}</div>
                  <div style={{ fontFamily: 'Montserrat', fontSize: '12px', color: '#666', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                    {stripHtml(a.conteudo)?.substring(0, 180)}...
                  </div>
                  {a.tags && a.tags.length > 0 && (
                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', marginTop: '8px' }}>
                      {a.tags.map((t, i) => <span key={i} style={{ padding: '2px 8px', borderRadius: '12px', fontSize: '10px', fontFamily: 'Montserrat', backgroundColor: '#f1f5f9', color: '#555' }}>#{t}</span>)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {preview && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '650px', maxHeight: '90vh', overflowY: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <span style={tagStyle(getCatColor(preview.categoria))}>{getCatLabel(preview.categoria)}</span>
                <button style={{ padding: '6px 14px', borderRadius: '8px', border: 'none', backgroundColor: '#e0e0e0', color: '#333', fontFamily: 'Montserrat', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                  onClick={() => setPreview(null)}>Fechar</button>
              </div>
              <h2 style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '700', color: '#1A3B7D', marginBottom: '16px' }}>{preview.titulo}</h2>
              <div style={{ marginBottom: '16px' }}>{renderizarHtml(preview.conteudo)}</div>
              {preview.tags && preview.tags.length > 0 && (
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', paddingTop: '16px', borderTop: '1px solid #eee' }}>
                  {preview.tags.map((t, i) => <span key={i} style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontFamily: 'Montserrat', backgroundColor: '#f1f5f9', color: '#555' }}>#{t}</span>)}
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </Layout>
  );
};

export default BaseConhecimentoAssociado;